<div class="restricted-message" *ngIf="resource?.res?.userHasPermission === 'RV' && showRestrictedMessage">
  <mat-icon>report_problem</mat-icon>
  <p>This resource is restricted, file representations may be of lower quality and some properties may be hidden.</p>
  <mat-icon class="close" (click)="showRestrictedMessage = false">clear</mat-icon>
</div>
<div class="content large middle">
  <div class="resource-view" *ngIf="resource">
    <!-- dsp-resource-representation -->
    <div
      class="representation-container center"
      *ngIf="representationsToDisplay?.length && representationsToDisplay[0].fileValue"
      [ngSwitch]="representationsToDisplay[0].fileValue?.type">
      <!-- still image view -->
      <app-still-image
        #stillImage
        class="dsp-representation stillimage"
        *ngSwitchCase="representationConstants.stillImage"
        [images]="representationsToDisplay"
        [imageCaption]="(incomingResource ? resource.res.label + ': ' + incomingResource.res.label : resource.res.label)"
        [compoundNavigation]="compoundPosition"
        [resourceIri]="incomingResource ? incomingResource.res.id : resource.res.id"
        [project]="resource.res.attachedToProject"
        [currentTab]="selectedTabLabel"
        [parentResource]="incomingResource ? incomingResource.res : resource.res"
        [activateRegion]="selectedRegion"
        [adminPermissions]="isAdmin$ | async"
        (loaded)="representationLoaded($event)"
        (goToPage)="compoundNavigation($event)"
        (regionClicked)="openRegion($event)"
        (regionAdded)="updateRegions($event)">
      </app-still-image>

      <app-document
        #document
        class="dsp-representation document"
        [class.pdf]="representationsToDisplay[0].fileValue.filename.split('.').pop() === 'pdf'"
        *ngSwitchCase="representationConstants.document"
        [src]="representationsToDisplay[0]"
        [parentResource]="resource.res"
        (loaded)="representationLoaded($event)">
      </app-document>

      <app-audio
        #audio
        class="dsp-representation audio"
        *ngSwitchCase="representationConstants.audio"
        [src]="representationsToDisplay[0]"
        [parentResource]="resource.res"
        (loaded)="representationLoaded($event)">
      </app-audio>

      <app-video
        #video
        class="dsp-representation video"
        *ngSwitchCase="representationConstants.movingImage"
        [src]="representationsToDisplay[0]"
        [parentResource]="resource.res"
        [splitSizeChanged]="splitSizeChanged"
        (loaded)="representationLoaded($event)">
      </app-video>

      <app-archive
        #archive
        class="dsp-representation archive"
        *ngSwitchCase="representationConstants.archive"
        [src]="representationsToDisplay[0]"
        [parentResource]="resource.res"
        (loaded)="representationLoaded($event)">
      </app-archive>

      <app-text
        #text
        class="dsp-representation text"
        *ngSwitchCase="representationConstants.text"
        [src]="representationsToDisplay[0]"
        [parentResource]="resource.res"
        (loaded)="representationLoaded($event)">
      </app-text>

      <span *ngSwitchDefault>
        The file representation type "{{representationsToDisplay[0].fileValue.type}}" is not yet implemented
      </span>

      <!-- TODO: here we'll add more viewers and players dsp-moving-image, dsp-audio etc. -->
    </div>
    <div class="data-container" *ngIf="!loading">
      <!-- tabs -->
      <mat-tab-group
        *ngIf="!resource.res.isDeleted; else deletedResource"
        animationDuration="0ms"
        [(selectedIndex)]="selectedTab"
        (selectedTabChange)="tabChanged($event)">
        <!-- first tab for the main resource e.g. book -->
        <mat-tab [label]="resource.res.entityInfo?.classes[resource.res.type].label">
          <app-properties
            *ngIf="resource.res"
            [resource]="resource"
            [displayProjectInfo]="true"
            [adminPermissions]="isAdmin$ | async"
            [valueUuidToHighlight]="valueUuid">
          </app-properties>
        </mat-tab>

        <!-- incoming resource -->
        <mat-tab
          *ngIf="incomingResource"
          [label]="incomingResource.res.entityInfo?.classes[incomingResource.res.type].label">
          <app-properties
            *ngIf="incomingResource.res"
            [resource]="incomingResource"
            [displayProjectInfo]="false"
            [adminPermissions]="isAdmin$ | async"
            [valueUuidToHighlight]="valueUuid">
          </app-properties>
        </mat-tab>

        <!-- annotations -->
        <mat-tab
          label="annotations"
          *ngIf="representationsToDisplay?.length && representationsToDisplay[0].fileValue && representationsToDisplay[0].fileValue.type === representationConstants.stillImage">
          <ng-template matTabLabel class="annotations">
            <span
              [matBadge]="representationsToDisplay[0]?.annotations.length"
              [matBadgeHidden]="representationsToDisplay[0]?.annotations.length === 0"
              matBadgeColor="primary"
              matBadgeOverlap="false">
              Annotations
            </span>
          </ng-template>
          <div
            class="region-property"
            *ngFor="let annotation of annotationResources"
            [id]="annotation.res.id"
            [class.active]="annotation.res.id === selectedRegion">
            <app-properties
              [resource]="annotation"
              [displayProjectInfo]="false"
              [isAnnotation]="true"
              [adminPermissions]="isAdmin$ | async"
              [valueUuidToHighlight]="valueUuid"
              (regionChanged)="updateRegion()"
              (regionDeleted)="reloadWithResource()">
            </app-properties>
          </div>
        </mat-tab>
      </mat-tab-group>
      <ng-template #deletedResource>
        <app-properties
          *ngIf="resource.res"
          [resource]="resource"
          [displayProjectInfo]="true"
          [adminPermissions]="isAdmin$ | async"
          [valueUuidToHighlight]="valueUuid">
        </app-properties>
      </ng-template>
    </div>
    <!-- progress indicator -->
    <dasch-swiss-app-progress-indicator *ngIf="loading"></dasch-swiss-app-progress-indicator>
  </div>

  <!-- resource not found  -->
  <div *ngIf="!resource && !loading" class="no-results">
    <p>
      The resource
      <span *ngIf="resourceIri">&mdash; <strong> {{resourceIri}}</strong> &mdash;</span>
      could not be found.
    </p>
    <p>Reasons:</p>
    <ul>
      <li>It could be a deleted resource and does not exist anymore.</li>
      <li>You don't have the permissions to open this resource.</li>
      <li>The identifier or the ARK URL is wrong.</li>
    </ul>
  </div>
</div>
